// extracted by mini-css-extract-plugin
module.exports = {"main":"ChatRoomMessageSpacer_main__3xcGz","size-small":"ChatRoomMessageSpacer_size-small__f8AQ9","size-medium":"ChatRoomMessageSpacer_size-medium__nmBHb"};